import React, { useEffect, useState } from "react";
import AdminHeader from "./AdminHeader";
import API_BASE_URL from "./api";
export default function AdminDashboard() {
  const [jobs, setJobs] = useState([]);
  const [admitCards, setAdmitCards] = useState([]);
  const [activeTab, setActiveTab] = useState("latestjobs");
  const [admissions, setAdmissions] = useState([]);
  const [results, setResults] = useState([]);

  const loadJobs = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/latest-jobs`, {
        credentials: "include"
      });
      const data = await res.json();
      if (Array.isArray(data)) setJobs(data);
    } catch (e) {
      console.error("loadJobs error", e);
    }
  };

  const loadAdmitCards = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admitcards`, {
        credentials: "include"
      });
      const data = await res.json();
      if (Array.isArray(data)) setAdmitCards(data);
    } catch (e) {
      console.error("loadAdmitCards error", e);
    }
  };

   const loadAdmissions = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admissions`, {
        credentials: "include"
      });
      const data = await res.json();
      if (Array.isArray(data)) setAdmissions(data);
    } catch (e) {
      console.error("loadAdmissions error", e);
    }
  };

  useEffect(() => {
    loadJobs();
    loadAdmitCards();
    loadAdmissions();
  }, []);

  return (
    <div>
      <AdminHeader />

      <main style={{ padding: 20, marginTop: 72 }}>
        {/* ----------- TABS ----------- */}
        <div style={{ display: "flex", marginBottom: 12 }}>
          {["latestjobs", "admitcards", "admissions", "results"].map(t => (
            <div
              key={t}
              onClick={() => setActiveTab(t)}
              style={{
                flex: 1,
                textAlign: "center",
                padding: 12,
                background: activeTab === t ? "#4287f5" : "#ddd",
                color: activeTab === t ? "white" : "black",
                cursor: "pointer"
              }}
            >
              {t.toUpperCase()}
            </div>
          ))}
        </div>

       {/* ----------- LATEST JOBS TAB ----------- */}
{activeTab === "latestjobs" && (
  <section>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <h2>Latest Jobs</h2>

      <button
        style={{
          padding: "8px 14px",
          background: "#28a745",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer"
        }}
        onClick={() => {
          window.location.href = "/admin/latestjobs/entry";  // ⬅ Redirect to job entry page
        }}
      >
        + Add Latest Job
      </button>
    </div>

    <ul style={{ marginTop: 12 }}>
      {jobs.length === 0 ? (
        <li>No jobs</li>
      ) : (
        jobs.map((j, i) => (
          <li key={i}>
            {j.post_name} — {j.organization_name} — {j.last_date}
          </li>
        ))
      )}
    </ul>
  </section>
)}


        {/* ----------- ADMIT CARDS TAB ----------- */}
        {activeTab === "admitcards" && (
          <section>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2>Admit Cards</h2>

              <button
                style={{
                  padding: "8px 14px",
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer"
                }}
                onClick={() => {
                  window.location.href = "/admin/admitcards/entry";
                }}
              >
                + Add Admit Card
              </button>
            </div>

            <ul style={{ marginTop: 12 }}>
              {admitCards.length === 0 ? (
                <li>No Admit Cards Found</li>
              ) : (
                admitCards.map((a, i) => (
                  <li key={i} style={{ marginBottom: 6 }}>
                    <strong>{a.admit_name}</strong> — {a.organization} —{" "}
                    {a.exam_date}
                  </li>
                ))
              )}
            </ul>
          </section>
        )}

        {/* ----------- OTHER TABS ----------- */}
        {/* ----------- ADMISSIONS TAB ----------- */}
{activeTab === "admissions" && (
  <section>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <h2>Admissions</h2>

      <button
        style={{
          padding: "8px 14px",
          background: "#28a745",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer"
        }}
        onClick={() => {
          window.location.href = "/admin/admissions/entry";
        }}
      >
        + Add Admission
      </button>
    </div>

    <ul style={{ marginTop: 12 }}>
      {admissions.length === 0 ? (
        <li>No Admissions Found</li>
      ) : (
        admissions.map((a, i) => (
          <li key={i} style={{ marginBottom: 6 }}>
            <strong>{a.course_name}</strong> — {a.organization} —{" "}
            {a.last_date}
          </li>
        ))
      )}
    </ul>
  </section>
)}
        {/* ----------- RESULTS TAB ----------- */}
{activeTab === "results" && (
  <section>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <h2>Results</h2>

      <button
        style={{
          padding: "8px 14px",
          background: "#28a745",
          color: "white",
          border: "none",
          borderRadius: 4,
          cursor: "pointer"
        }}
        onClick={() => {
          window.location.href = "/admin/results/entry";
        }}
      >
        + Add Result
      </button>
    </div>

    <ul style={{ marginTop: 12 }}>
      {results.length === 0 ? (
        <li>No Results Found</li>
      ) : (
        results.map((r, i) => (
          <li key={i} style={{ marginBottom: 6 }}>
            <strong>{r.result_name}</strong> — {r.organization} —{" "}
            {r.result_date}
          </li>
        ))
      )}
    </ul>
  </section>
)}
      </main>
    </div>
  );
}

